'use client';

import React, { useState } from 'react';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import AuthBrandPanel from './AuthBrandPanel';

export default function AuthScreen() {
  const [activeTab, setActiveTab] = useState<'login' | 'register'>('login');

  return (
    <div
      className="min-h-screen flex"
      style={{ background: 'var(--background)' }}
    >
      {/* Left brand panel — hidden on mobile */}
      <div className="hidden lg:flex lg:w-[55%] xl:w-[60%] flex-col">
        <AuthBrandPanel />
      </div>

      {/* Right form panel */}
      <div
        className="flex-1 lg:w-[45%] xl:w-[40%] flex flex-col items-center justify-center px-6 py-10 relative overflow-y-auto"
        style={{ background: 'var(--card)' }}
      >
        {/* Mobile logo */}
        <div className="lg:hidden flex items-center gap-2 mb-8">
          <div
            className="w-9 h-9 rounded-xl flex items-center justify-center"
            style={{ background: 'var(--primary)' }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
              <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" />
            </svg>
          </div>
          <span className="font-bold text-lg" style={{ color: 'var(--foreground)' }}>
            AWS Club Portal
          </span>
        </div>

        <div className="w-full max-w-md">
          {/* Tab switcher */}
          <div
            className="flex rounded-xl p-1 mb-8"
            style={{ background: 'var(--muted)' }}
          >
            {(['login', 'register'] as const).map((tab) => (
              <button
                key={`tab-${tab}`}
                onClick={() => setActiveTab(tab)}
                className={`flex-1 py-2.5 text-sm font-600 rounded-lg transition-all duration-200 ${
                  activeTab === tab ? 'tab-active' : ''
                }`}
                style={
                  activeTab !== tab
                    ? { color: 'var(--muted-foreground)' }
                    : {}
                }
              >
                {tab === 'login' ? 'Sign In' : 'Register'}
              </button>
            ))}
          </div>

          {/* Form */}
          <div className="fade-in">
            {activeTab === 'login' ? (
              <LoginForm onSwitchToRegister={() => setActiveTab('register')} />
            ) : (
              <RegisterForm onSwitchToLogin={() => setActiveTab('login')} />
            )}
          </div>
        </div>

        {/* Footer */}
        <p className="mt-8 text-xs" style={{ color: 'var(--muted-foreground)' }}>
          AWS Student Builder Club · CSE Department · 2025–26
        </p>
      </div>
    </div>
  );
}